module.exports = __webpack_public_path__ + "img/equipos.7797d191.svg";